const GA_MEASUREMENT_ID = 'G-SHBDZ9THFK';

/**
 * Met à jour document.title et envoie un page_view GA4 (prod uniquement).
 * @param {string} pageTitle
 * @param {string} [pagePath] — défaut : pathname + search courants
 */
export function trackAnalyticsPageView(pageTitle, pagePath) {
	if (typeof document !== 'undefined') {
		document.title = pageTitle;
	}
	if (process.env.NODE_ENV !== 'production') return;
	if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;

	const path = pagePath ?? `${window.location.pathname}${window.location.search}`;
	window.gtag('event', 'page_view', {
		send_to: GA_MEASUREMENT_ID,
		page_title: pageTitle,
		page_location: window.location.href,
		page_path: path,
	});
}
